<template>
  <div ref="chart">
    <Chart :extendData="extendData" :height="height" :id="id" :option="option" :width="width"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';

export default {
  name: "DynamicLineChart1",
  components: {Chart},
  props: {
    data: {},
    extendData: null,
  },
  data() {
    return {
      id: "lineChart",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  watch: {
    data: {
      handler() {
        this.getOption();
      },
      deep: true
    },
  },
  mounted() {
    this.getOption()
  },
  methods: {
    getOption: function () {
      let labelColor = 'rgba(73,164,243,0.2)';
      const colorList = ["#07E6F8", '#ECBB18', '#2771EF', '#8427EF', '#27ABEF'];
      let series = []
      Object.keys(this.data.data).forEach((item,i) =>{
        const data = this.data.data[item]
        const color = colorList[i % colorList.length]
        const seriesItem = {
          name: data.name,
          data: data.value,
          type: 'line',
          symbolSize: 1,
          symbol: 'circle',
          smooth: true,
          yAxisIndex: 0,
          showSymbol: false,
          lineStyle: {
            normal: {
              color: color,
            }
          },
          itemStyle: {
            normal: {
              color: color,
              borderColor: color
            }
          }
        }
        series.push(seriesItem)
      })
      let interval = 0
      if (this.data.time.length > 20){
        interval = parseInt(this.data.time.length/30)
      }

      this.option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            label: {
              show: false,
              backgroundColor: 'rgba(0,0,0,0)',
              color: '#556677',
              borderColor: 'rgba(0,0,0,0)',
              shadowColor: 'rgba(0,0,0,0)',
              shadowOffsetY: 0
            },
            lineStyle: {
              width: 0
            }
          },
          backgroundColor: 'rgba(0,0,0,0.5)',
          textStyle: {
            color: '#fff'
          },
          padding: [10, 10],
          extraCssText: 'box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)'
        },
        grid: {
          top: '8%',
          right: '7%',
          left: '7%',
          bottom: '10%',
          // containLabel: true
        },
        legend: {
          show: true,
          top: '3%',
          textStyle: {
            color: "#fff",
            fontSize: 12
          },
        },
        xAxis: [{
          type: 'category',
          // splitNumber: 5,
          data: this.data.time,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: interval,
            textStyle: {
              color: '#8DB0CB'
            },
            // 默认x轴字体大小
            fontSize: 12,
            // margin:文字到x轴的距离
            margin: 15
          },
          boundaryGap: ['20%', '20%']
        }],
        yAxis: [{
          name: '',
          type: 'value',
          nameTextStyle: {
            color: labelColor,
            fontSize: 12,
          },
          axisTick: {
            show: false
          },
          axisLine: {
            // show: false,
            lineStyle: {
              color: labelColor
            }
          },
          axisLabel: {
            textStyle: {
              color: '#8DB0CB'
            },
            formatter: '{value}'
          },
          splitLine: {
            lineStyle: {
              color: labelColor
            }
          },
        }],
        series: series
      };

    },
  },
}
</script>

<style scoped>

</style>
